import createVuexModule from '~/store/utils/createVuexModule';
import { AdyenErrorState } from '~/types/vuex/AdyenError';

export default createVuexModule<AdyenErrorState['error']>({
  stateKey: 'error',
  initialValue: null,
  mutationName: 'setError',
});
